import { atom } from 'jotai';
import type { Handler, HandlerArgs } from './types';

export const openAtom = atom<boolean>(false);

export const messageAtom = atom<string | null>(null);

export const handlerAtom = atom<Handler | null>(null);

export const handlerArgsAtom = atom<HandlerArgs>([]);
